import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function RequireAuth({ children }) {
  const { isAuthenticated, initialising } = useAuth();
  const location = useLocation();

  if (initialising) {
    // You can return a spinner here if you like
    return null;
  }

  if (!isAuthenticated) {
    // Redirect to /login and remember where we came from
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
